import styled from 'styled-components';
import {textColorLight} from 'styles/constants';
import {textStyles} from 'styles/fragments';

export default styled.span`
	${textStyles.caption};
	color: ${textColorLight};
	display: ${({block}) => (block ? 'block' : 'inline')};
`;
